import { Colors } from '@fourthwall/components';
import styled from 'styled-components';
export const Container = styled.div `
  width: 100%;
  background: ${Colors.GS0};
  padding: 0 4px;
  display: flex;
  flex-direction: column;
  max-height: 370px;
`;
export const HeaderContainer = styled.div `
  padding: 4px 0;
  border-bottom: 1px solid ${Colors.GS300};
  flex: 1;
`;
export const OptionsList = styled.div `
  overflow-y: auto;
  flex: 1;
  padding: 4px 0;
`;
export const OptionWrapper = styled.div ``;
